import { combineReducers } from 'redux';
import toast from './toast/reducer';

export default combineReducers({ toast });
